"use client"

import { hotelActions } from "@/lib/redux/features/hotel/reduce"
import { HotelLocation } from "@/lib/redux/features/hotel/type"
import { FC, ReactNode, useLayoutEffect } from "react"
import { storeRef } from "../providers/StoreProvider"

type HotelDestinationContainerProps = {
  children: ReactNode,
  vietnamPopularDestinations: HotelLocation[],
  internationalPopularDestinations: HotelLocation[],
}

const HotelDestinationContainer: FC<HotelDestinationContainerProps> = ({ children, vietnamPopularDestinations, internationalPopularDestinations }) => {
  // Do not dispatch during render — that updates destination UI mid-render.
  useLayoutEffect(() => {
    storeRef?.current?.dispatch(hotelActions.setPopularDestinations({
      vietnam: vietnamPopularDestinations,
      international: internationalPopularDestinations,
      show: 'INTERNAL'
    }))
  }, [vietnamPopularDestinations, internationalPopularDestinations])

  return children
}

HotelDestinationContainer.displayName = 'HotelDestinationContainer'

export default HotelDestinationContainer
